import React, { useEffect, useState } from "react";
import { CommandDialog, CommandInput, CommandList, CommandGroup, CommandItem, CommandEmpty } from "./ui/command";
import api from "../lib/api";
import { Users, FileText } from "lucide-react";

export function GlobalSearch({ open, onClose, onNavigate }) {
  const [q, setQ] = useState("");
  const [res, setRes] = useState({ clients: [], documents: [] });

  useEffect(() => {
    if (!q) { setRes({ clients: [], documents: [] }); return; }
    const t = setTimeout(() => {
      api.get(`/search?q=${encodeURIComponent(q)}`).then(({ data }) => setRes(data)).catch(() => {});
    }, 250);
    return () => clearTimeout(t);
  }, [q]);

  return (
    <CommandDialog open={open} onOpenChange={(o) => !o && onClose()}>
      <CommandInput placeholder="Müvekkil, numara veya belge ara…" value={q} onValueChange={setQ} data-testid="global-search-input" />
      <CommandList>
        <CommandEmpty>Sonuç bulunamadı.</CommandEmpty>
        {res.clients.length > 0 && (
          <CommandGroup heading="Müvekkiller">
            {res.clients.map((c) => (
              <CommandItem key={c.id} value={`c-${c.id}-${c.name}`} onSelect={() => onNavigate(c.id)}>
                <Users className="w-4 h-4 mr-2 text-navy-900" /> {c.client_no} — {c.name}
              </CommandItem>
            ))}
          </CommandGroup>
        )}
        {res.documents.length > 0 && (
          <CommandGroup heading="Belgeler">
            {res.documents.map((d) => (
              <CommandItem key={d.id} value={`d-${d.id}`} onSelect={() => d.client_id && onNavigate(d.client_id)}>
                <FileText className="w-4 h-4 mr-2 text-navy-900" /> {d.file_name}
              </CommandItem>
            ))}
          </CommandGroup>
        )}
      </CommandList>
    </CommandDialog>
  );
}
